const axios = require('axios');
import {getBaseURL, getDominio} from "../../config"

// create an axios instance
const service = axios.create({
  baseURL: getBaseURL()+'site/',
  timeout: 30000 // 30 segundos esperando resposta
});

// request interceptor
service.interceptors.request.use(
 config => {
   config.headers['Web-Dom'] = getDominio();
   return config
 },
 error => {
   return Promise.reject(error)
 }
);

service.interceptors.response.use(
 response => {
   const {data, status} = response;
   if (!data.status) {
     return Promise.reject(new Error(data.mensagem || 'Error'))
   } else {
     return data
   }
 },
 error => {
   if (typeof error.response === "undefined") {
     return Promise.reject(error);
   }
   const {data, status} = error.response;
   return Promise.reject(error);
 }
);

export default service
